import React from 'react';
// @ts-ignore
import Plot from 'react-plotly.js';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme, WithTheme } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import Grid from '@material-ui/core/Grid';
import { QRLabelMapJSON } from '../../Quantification/QuantificationResultJSON';

const styles = (theme: Theme) => createStyles({
  plotRoot: {
    width: '100%',
    margin: 0,
    background: 'unset',
  },
  plotPaper: {
    overflow: 'hidden',
    marginBottom: theme.spacing(1),
  },
  root: {
    flexGrow: 1,
  },
});

interface Props extends WithStyles<typeof styles>, WithTheme {
  data: TableCellData[];
  map: QRLabelMapJSON;
}

interface TableCellData {
  Conditional: number;
  Criticality: number;
  Diagnostic: number;
  Marginal: number;
  Potential: number;
  RAW: number;
  RRW: number;
  basic_event: string;
  scenario: string;
}

/**
 * SingleHCL quantification result
 * This is an Alternate View to supplement the existing table view of the importance measures
 * This will provide a visual representation of comparisons of the importance computed by each method between all basic events
 */

class ImportanceMeasurePlot extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  private buildPlot = (title: string) => {
    const { data, theme, map } = this.props;
    return (
      <Grid item xs={12} sm={6} md={4}>
        <Plot
          style={{ width: '100%' }}
          data={[
            {
              type: 'bar',
              x: data.map((row: TableCellData) => {
                try {
                  return map[row.basic_event].label.name;
                } catch (e) {
                  console.error(e);
                  return 'Undefined';
                }
              }),
              // @ts-ignore
              y: data.map((row: TableCellData) => row[title]),
              marker: {
                color: 'rgba(140,56,196,0.66)',
                line: {
                  width: 2,
                },
              },
            },
          ]}
          config={{
            displaylogo: false,
            autosizable: true,
            responsive: true,
          }}
          layout={{
            title,
            paper_bgcolor: 'transparent',
            plot_bgcolor: 'transparent',
            font: {
              color: theme.palette.text.primary,
              family: theme.typography.fontFamily,
              size: theme.typography.fontSize,
            },
            xaxis: {
              color: theme.palette.text.secondary,
              gridcolor: theme.palette.text.secondary,
            },
            yaxis: {
              color: theme.palette.text.secondary,
              gridcolor: theme.palette.text.secondary,
            },
            // width: 400,
            height: 400,
            margin: {
              t: 35,
              b: 125,
              l: 25,
              r: 15,
            },
          }}
        />
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Grid container spacing={10}>
          {this.buildPlot('Conditional')}
          {this.buildPlot('Marginal')}
          {this.buildPlot('Potential')}
          {this.buildPlot('Diagnostic')}
          {this.buildPlot('RAW')}
          {this.buildPlot('RRW')}
          {this.buildPlot('Criticality')}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ImportanceMeasurePlot);
